<template>
  <div v-if="visibleIcons.length > 0" class="flex items-center gap-1">
    <!-- Show +N indicator if there are more than 2 icons -->
    <div
      v-if="hasOverflow"
      class="relative"
      @mouseenter="showTooltip = true"
      @mouseleave="showTooltip = false"
    >
      <div
        class="w-6 h-6 rounded-full border flex items-center justify-center text-xs font-bold cursor-pointer"
        :aria-label="`${overflowCount} אזהרות נוספות`"
      >
        +{{ overflowCount }}
      </div>

      <!-- Tooltip for overflow icons -->
      <div
        v-if="showTooltip"
        class="absolute z-50 bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-white shadow-lg rounded-lg p-3 w-max max-w-[200px] sm:max-w-xs"
      >
        <div class="flex flex-col gap-2">
          <div
            v-for="icon in overflowIcons"
            :key="icon.key"
            class="flex items-center gap-2"
          >
            <img
              :src="icon.src"
              :alt="icon.label"
              :aria-label="icon.label"
              class="w-8 h-8"
            />
            <span class="text-sm text-grays-900 whitespace-nowrap">{{
              icon.label
            }}</span>
          </div>
        </div>
        <!-- Arrow pointer -->
        <div
          class="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-white"
        ></div>
      </div>
    </div>
    <!-- Display first icon or up to 2 icons -->
    <img
      v-for="icon in displayedIcons"
      :key="icon.key"
      :src="icon.src"
      :alt="icon.label"
      :aria-label="icon.label"
      :title="icon.label"
      class="w-8 h-8"
    />
  </div>
</template>

<script>
export default {
  name: "ProductIcons",
  props: {
    product: {
      type: Object,
      required: true,
    },
    maxVisible: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      showTooltip: false,
      iconMapping: {
        high_sugar: {
          src: new URL("@/assets/icons/product/high-sugar.svg", import.meta.url)
            .href,
          label: "סוכר גבוה",
        },
        high_fat: {
          src: new URL("@/assets/icons/product/high-fat.svg", import.meta.url)
            .href,
          label: "שומן גבוה",
        },
        high_sodium: {
          src: new URL(
            "@/assets/icons/product/high-sodium.svg",
            import.meta.url
          ).href,
          label: "נתרן גבוה",
        },
      },
    };
  },
  computed: {
    visibleIcons() {
      const icons = [];

      // Map FSR keys to icon mapping keys
      const fsrKeyMap = {
        FSR2: "high_sodium",
        FSR3: "high_sugar",
        FSR4: "high_fat",
      };

      // Read nutrition_flags from the new data structure: product.product.barcodes[0].nutrition_flags
      const nutritionFlags =
        this.product?.product?.barcodes?.[0]?.nutrition_flags ?? [];

      nutritionFlags.forEach((flagEntry) => {
        const fsrKey = flagEntry?.nutrition_flag?.key;
        const iconKey = fsrKeyMap[fsrKey];
        if (iconKey && this.iconMapping[iconKey]) {
          icons.push({
            key: iconKey,
            src: this.iconMapping[iconKey].src,
            label: this.iconMapping[iconKey].label,
          });
        }
      });

      return icons;
    },
    displayedIcons() {
      // If more than 2 icons, show only the first one
      // Otherwise, show up to 2 icons
      if (this.visibleIcons.length > 2) {
        return this.visibleIcons.slice(0, 1);
      }
      return this.visibleIcons.slice(0, 2);
    },
    overflowIcons() {
      // If more than 2 icons, overflow starts from the second icon
      if (this.visibleIcons.length > 2) {
        return this.visibleIcons.slice(1);
      }
      return [];
    },
    hasOverflow() {
      return this.visibleIcons.length > 2;
    },
    overflowCount() {
      return this.visibleIcons.length - 1; // Total minus the 1 shown
    },
  },
};
</script>

<style scoped>
/* Additional styling if needed */
</style>
